<template>
    <div>
        <p class="lead text-left my-4">{{ areaTitle }}</p>
            <div class="text-left my-4">
                <router-link :to="{name: 'Admin'}" class="text-success">Admin</router-link> 
                    <i class="fas fa-backward"></i> 
                        <span class="text-info">{{ menuItem }}</span>
            </div> 
    </div>
</template>

<script>
    export default {
        props: ['areaTitle', 'menuItem']
    }
</script>




// WEBPACK FOOTER //
// src/components/Helpers/PageHeader.vue